import * as yup from "yup";

export const audienceSchema = yup.object({
  topic: yup.string().required(),
});

export type AudienceSchema = yup.InferType<typeof audienceSchema>;
